<!--ikke-flerdags møte-->
<fieldset [formGroup]="skjema">
  <mat-form-field class="startdato">
    <mat-label>{{ "Møtedato"|translate }}</mat-label>
    <input matInput [matDatepicker]="startdatoVelger" formControlName="startdato" data-testid="startdato-felt" #startdatofelt>
    <mat-datepicker-toggle matPrefix [for]="startdatoVelger"/>
    <mat-datepicker #startdatoVelger/>
    @if(skjema.controls.startdato.hasError('matDatepickerParse')){
      <mat-error data-testid="matDatepickerParse">{{ skjema.controls.startdato.errors | standardvalideringsfeil:'matDatepickerParse' }}</mat-error>
    }
    @if(skjema.controls.startdato.hasError('overlapper')){
      <mat-error data-testid="overlapper">{{ "Møte overlapper eksisterende møte"|translate }}</mat-error>
    }
    @if(skjema.controls.startdato.hasError('protokollLaast')){
      <mat-error data-testid="protokollLaast">{{ "Det finnes møter etter {startdato} med låst protokoll, du kan ikke opprette eller flytte møter til før møter med låst protokoll."|translate: {startdato: skjema.value.startdato | plaindate} }}</mat-error>
    }
    @if(skjema.controls.startdato.hasError('startEtterSlutt')){
      <mat-error data-testid="startEtterSlutt">{{ "Startdato må være tidligere enn sluttdato."|translate }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field class="startklokkeslett">
    <mat-label>{{ "Starttidspunkt"|translate }}</mat-label>
    <klokkeslett-velger formControlName="startklokkeslett" data-testid="starttidspunkt-felt"/>
    <mat-icon matPrefix fontSet="ion-ios-clock-outline" class="mat-icon--ionic-ikon"/>
  </mat-form-field>

  @if(!skjema.controls.flerdags.value){
    <mat-form-field class="sluttklokkeslett">
      <mat-label>{{ "Sluttidspunkt"|translate }}</mat-label>
      <varighet-velger formControlName="sluttklokkeslett" [starttidspunkt]="sisteGyldigStartklokkeslett()" data-testid="slutttidspunkt-felt"/>
      <mat-icon matPrefix fontSet="ion-ios-stopwatch-outline" class="mat-icon--ionic-ikon"/>
    </mat-form-field>
  }
  @else {
    <mat-form-field class="sluttdato">
      <mat-label>{{ "Sluttdato"|translate }}</mat-label>
      <input matInput [matDatepicker]="sluttdatoVelger" [min]="skjema.controls.startdato.value" placeholder="dd.mm.yyyy" formControlName="sluttdato" data-testid="sluttdato-felt" #sluttdatofelt>
      <mat-datepicker-toggle matPrefix [for]="sluttdatoVelger"/>
      <mat-datepicker #sluttdatoVelger/>
      @if(skjema.controls.sluttdato.hasError('matDatepickerMin')){
        <mat-error data-testid="startEtterSlutt">{{ "Startdato må være tidligere enn sluttdato."|translate }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="sluttklokkeslett">
      <mat-label>{{ "Sluttidspunkt"|translate }}</mat-label>
      <klokkeslett-velger formControlName="sluttklokkeslett" data-testid="slutttidspunkt-felt"/>
      <mat-icon matPrefix fontSet="ion-ios-clock-outline" class="mat-icon--ionic-ikon"/>
    </mat-form-field>
  }

  <mat-checkbox formControlName="flerdags" data-testid="flerdags-felt">{{ "Flerdags"|translate }}</mat-checkbox>
</fieldset>

@if(visIngenPlanMelding()){
  <tips [ngStyle]="{'margin-top':(skjema.controls.startdato.invalid ? '20':'0')+'px'}" class="e2e-opprettplantips">
    <span>
      {{ "Det finnes ingen årsplan som dekker angitt møtedato,"|translate }}
    </span>
    <a (click)="opprettAarsplan()" class="e2e-opprettplan">{{ "opprette en ny årsplan?"|translate }}</a>
  </tips>
}
